import React from "react";
import { Helmet } from "react-helmet-async";
import "./styles/MentionsLegales.css";

const MentionsLegales = () => {
  return (
    <main className="mentions">
      <Helmet>
        <title>Mentions légales - WinlyDeal</title>

        <meta 
          name="description" 
          content="Retrouvez toutes les informations légales concernant WinlyDeal : éditeur du site, hébergeur, propriété intellectuelle, protection des données et utilisation des cookies." 
        />
        <meta 
          name="keywords" 
          content="mentions légales, éditeur site, hébergement, propriété intellectuelle, protection données personnelles, cookies, WinlyDeal"
        />
        <link rel="canonical" href="https://winlydeal.com/mentions-legales" />
        
        <meta name="robots" content="noindex, nofollow" />

        <meta property="og:title" content="Mentions légales - WinlyDeal" />
        <meta 
          property="og:description" 
          content="Consultez les mentions légales de WinlyDeal pour connaître l'éditeur, l'hébergeur, les règles de propriété intellectuelle et notre politique de confidentialité." 
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://winlydeal.com/mentions-legales" />
        <meta property="og:image" content="https://winlydeal.com/images/og-image.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mentions légales - WinlyDeal" />
        <meta 
          name="twitter:description" 
          content="Toutes les informations légales sur l'éditeur du site, l'hébergeur, la propriété intellectuelle et la protection des données sur WinlyDeal." 
        />
        <meta name="twitter:image" content="https://winlydeal.com/images/og-image.jpg" />
      </Helmet>

      <h1 className="mentions-title">Mentions Légales</h1>

      <section className="mentions-section">
        <h2 className="mentions-subtitle">1. Éditeur du site</h2>
        <p className="mentions-text">WinlyDeal - Florian Da Cunha</p>
        <p className="mentions-text">Email : support@winlydeal.com</p>
        <p className="mentions-text">Téléphone : +33 6 18 15 62 74</p>
      </section>

      <section className="mentions-section">
        <h2 className="mentions-subtitle">2. Hébergement</h2>
        <p className="mentions-text">
          Le site est hébergé sur un serveur privé détenu par l'éditeur.
        </p>
        <p className="mentions-text">
          La gestion du nom de domaine (DNS) est assurée par OVHcloud - 2 rue Kellermann, 59100 Roubaix, France.
        </p>
      </section>

      <section className="mentions-section">
        <h2 className="mentions-subtitle">3. Propriété Intellectuelle</h2>
        <p className="mentions-text">
          L'ensemble du contenu présent sur ce site est protégé par le droit français et international de la propriété intellectuelle.
        </p>
      </section>

      <section className="mentions-section">
        <h2 className="mentions-subtitle">4. Protection des Données</h2>
        <p className="mentions-text">
          Conformément au RGPD, chaque utilisateur dispose d'un droit d'accès, de rectification et de suppression de ses données personnelles. 
          Pour toute demande : support@winlydeal.com
        </p>
      </section>

      <section className="mentions-section">
        <h2 className="mentions-subtitle">5. Utilisation de Cookies</h2>
        <p className="mentions-text">
          WinlyDeal utilise uniquement des cookies strictement nécessaires au bon fonctionnement du site. 
          Aucune exploitation commerciale des données sans votre consentement.
        </p>
      </section>
    </main>
  );
};

export default MentionsLegales;
